import React, { useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Packages.css'
import { useTranslation } from "../../../utils/hooks/translateHook";

function Packages() {
  const navigate = useNavigate();
  const t = useTranslation();

  return (
    <section name="package-card-container" className="container">
      <h1>PACKAGE INFORMATION</h1>
      <div className="container-grid">
        <div className="container-grid-item" name="demo-card">
          <div className="card-header">DEMO</div>
          <div className="text-container">
            <div className="text-content">Great for beginners who are curious about getting an education online</div>
            <div className="card-line"></div>
            <div className="text-bottom-content">
              <ul>
                <li>Glossary</li>
              </ul>
            </div>
          </div>
          <div className="card-number">1</div>
          <div className="card-bottom"></div>
        </div>
        
        <div className="container-grid-item" name="starter-card">
          <div className="card-header starter">STARTER</div>
          <div className="text-container">
            <div className="text-content">Good for those who know the basic concepts and willing to learn</div>
            <div className="card-line"></div>
            <div className="text-bottom-content starter">
              <ul>
                <li>Demo Pack</li>
                <li>Introduction to Financial Markets EBook</li>
              </ul>
            </div>
          </div>
          <div className="card-number starter" >2</div>
          <div className="card-bottom starter"></div>
        </div>

        <div className="container-grid-item" name="junior-card">
          <div className="card-header junior">JUNIOR</div>
          <div className="text-container">
            <div className="text-content">Geared towards those seeling to expand their trading scope & the knowledge</div>
            <div className="card-line"></div>
            <div className="text-bottom-content junior">
              <ul>
                <li>Starter Pack</li>
                <li>Cryptocurrency Fundamentals EBook</li>
              </ul>
            </div>
          </div>
          <div className="card-number junior" >3</div>
          <div className="card-bottom junior"></div>
        </div>

        <div className="container-grid-item" name="basic-card">
          <div className="card-header basic">BASIC</div>
          <div className="text-container">
            <div className="text-content">Crafted for those who want to stay on track during the learning process.</div>
            <div className="card-line"></div>
            <div className="text-bottom-content basic">
              <ul>
                <li>Junior Pack</li>
                <li>Content</li>
                <li>Economic Calendar</li>
              </ul>
            </div>
          </div>
          <div className="card-number basic" >4</div>
          <div className="card-bottom basic"></div>
        </div>

        <div className="container-grid-item" name="beginner-card">
          <div className="card-header beginner">BEGINNER</div>
          <div className="text-container">
            <div className="text-content">Perfect for those who are new to the industry and looking to learn the essentials</div>
            <div className="card-line"></div>
            <div className="text-bottom-content beginner">
              <ul className="beginner">
                <li>Basic Pack</li>
                <li>Cryptocurrency Fundamentals Course</li>
              </ul>
            </div>
          </div>
          <div className="card-number beginner" >5</div>
          <div className="card-bottom beginner"></div>
        </div>

        <div className="container-grid-item" name="intermediate-card">
          <div className="card-header intermediate">INTERMEDIATE</div>
          <div className="text-container">
            <div className="text-content intermediate">Ideal for those with some industry experience looking to deepen their knowledge</div>
            <div className="card-line"></div>
            <div className="text-bottom-content intermediate">
              <ul className="intermediate">
                <li>Begginer Pack</li>
                <li>Cryptotrading & Investing Course</li>
                <li>Cryptotrading & Investing EBook</li>
                <li>Tech. Analysis Ess. Course</li>
                <li>Tech. Analysis Ess. EBook</li>
              </ul>
            </div>
          </div>
          <div className="card-number intermediate" >6</div>
          <div className="card-bottom intermediate"></div>
        </div>

        <div className="container-grid-item" name="advanced-card">
          <div className="card-header advanced">ADVANCED</div>
          <div className="text-container">
            <div className="text-content advanced">Perfect for those on the path of exploration into advanced trading</div>
            <div className="card-line"></div>
            <div className="text-bottom-content advanced">
              <ul className="advanced">
                <li>Intermediate Pack</li>
                <li>Advanced Tech Analysis Course</li>
              </ul>
            </div>
          </div>
          <div className="card-number advanced" >7</div>
          <div className="card-bottom advanced"></div>
        </div>

        <div className="container-grid-item" name="trader-card">
          <div className="card-header trader">TRADER</div>
          <div className="text-container">
            <div className="text-content trader">Perfect for those into advanced trading</div>
            <div className="card-line"></div>
            <div className="text-bottom-content trader">
              <ul className="trader">
                <li>Advanced Pack</li>
                <li>Advanced Tech Analysis Course</li>
                <li>Advanced Tech Analysis Ebook</li>
                <li>MetaTrader Tutorials</li>
                <li>Trading Signals</li>
                <li>Trend Analysis & Knowledge checks</li>
              </ul>
            </div>
          </div>
          <div className="card-number trader">8</div>
          <div className="card-bottom trader"></div>
        </div>

        <div className="container-grid-item" name="elite-card">
          <div className="card-header elite">ELITE</div>
          <div className="text-container">
            <div className="text-content elite">Advanced knowledge meets strategy building</div>
            <div className="card-line"></div>
            <div className="text-bottom-content elite">
              <ul className="trader">
                <li>Trader Pack</li>
                <li>Expert Tech Analysis Course</li>
                <li>Market Research Videos</li>
                <li>Tech Analysis Articles</li>
              </ul>
            </div>
          </div>
          <div className="card-number elite">9</div>
          <div className="card-bottom elite"></div>
        </div>

        <div className="container-grid-item" name="pro-card">
          <div className="card-header pro">PRO</div>
          <div className="text-container">
            <div className="text-content">Perfect for gaining more skills and depth</div>
            <div className="card-line"></div>
            <div className="text-bottom-content pro">
              <ul className="beginner">
                <li>Elite Pack</li>
                <li>Market Research Videos</li>
              </ul>
            </div>
          </div>
          <div className="card-number pro" >10</div>
          <div className="card-bottom pro"></div>
        </div>

        <div className="container-grid-item" name="senior-card">
          <div className="card-header senior">SENIOR</div>
          <div className="text-container">
            <div className="text-content">The most advanced pack for learning & knowledge</div>
            <div className="card-line"></div>
            <div className="text-bottom-content senior">
              <ul className="beginner">
                <li>Pro Pack</li>
                <li>Market Highlights TV</li>
                <li>Market Scanners</li>
              </ul>
            </div>
          </div>
          <div className="card-number senior" >11</div>
          <div className="card-bottom senior"></div>
        </div>
      </div>

    </section>
  )
}


export default Packages;